export * from './loader.component';
